import PropTypes from 'prop-types';
import React from 'react'
import ReactTooltip from 'react-tooltip'

import { Icon } from '~/components'


export default class extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		editing_fields: PropTypes.bool.isRequired,
		updateField: PropTypes.func.isRequired,
	};

    constructor(props) {
        super(props);
        let state = { sms: ['facebook', 'twitter', 'linkedin'], correct: {} };
        for (var i = 0; i < state.sms.length; i++) {
			state.correct[ state.sms[i] ] = false
		}
        this.state = state;
    }

    componentDidMount() {
		for (var i = 0; i < this.state.sms.length; i++) {
			var sm = this.state.sms[i];
			this.state.correct[ sm ] = this.validateURL(sm, this.props.user[sm+'_url'])
		}
	}

    validateURL = (sm, val) => {

		var expression = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
		var regex = new RegExp(expression);

		let correct = this.state.correct,
			matches = val.match(regex);
			
		correct[sm] = !!matches
		this.setState({
			correct: correct
		})

		//console.log(this.state.correct)

		return correct[sm] ? 'https://' + matches[0] : false;

	};

    updateField = (sm, e) => {
		let val = this.validateURL(sm, e.target.value)
		if( !val ) return;
		this.props.updateField(sm, val)
	};

    getLinkedIcon = (user, sm) => {
		return <a href={user[sm + '_url']} target="_blank" className="text-mid-main mright10"><Icon icon={sm} /></a>
	};

    getEditableField = (user, sm) => {
		return <span className="mright10">

			<a data-for={"social-"+sm} className="no-style" data-tip="custom show" data-event='click focus' ref='triggerTooltip' data-class="social-field-tooltip"><Icon icon={sm} /></a>

			<ReactTooltip place="right" id={"social-"+sm} type="light" border effect="solid">
				<input onChange={this.updateField.bind(this, sm)} className={"form-control " + (this.state.correct[sm] ? 'border-bottom-mid-success' : 'border-bottom-mid-danger')} defaultValue={user[sm+'_url']} maxLength="80" />
			</ReactTooltip>

		</span>
	};

    render() {

		let sms = this.state.sms,
			{ user, editing_fields } = this.props;
		
		return (
		
			<h6 className="mtop0 mbot20 mbot10-xs">
				{ 
					sms.map(function(sm) {
						return <span key={'sm-'+sm}>
							{ editing_fields
								? this.getEditableField(user, sm)
								: !!user[sm + '_url'] ? this.getLinkedIcon(user, sm) : <Icon icon={sm} className='text-dark-gray mright10' />
							}
						</span>
					}, (this))
				}
			</h6>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Header/components/Social.jsx